import '../styles/globals.css'
import type { AppProps } from 'next/app'
import Head from 'next/head'
import { ChakraProvider } from '@chakra-ui/react'
import { RecoilRoot } from 'recoil'
import theme from '../theme/index'
import dayjs from 'dayjs'
import ja from 'dayjs/locale/ja'
import relativeTime from 'dayjs/plugin/relativeTime'

MyApp.getInitialProps = async () => ({ pageProps: {} })

dayjs.locale(ja)
dayjs.extend(relativeTime)

import { useRecoilState } from 'recoil'
import meAtom from 'recoil/me'
import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { isPermitted } from 'lib/permission'
import * as Sentry from '@sentry/react'

import ErrorFallback from 'pages/_error'
import { GoogleAnalytics, usePagesViews } from 'nextjs-google-analytics'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BranchTermsModals } from 'components/domain/branchTerms/BranchTermsModals'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 300000,
    },
  },
})

function AppInit() {
  const [me] = useRecoilState(meAtom)
  const router = useRouter()

  useEffect(() => {
    if (me === undefined || !router.isReady) return
    if (!isPermitted(me.branch.user_type, router.pathname)) {
      router.replace('/forbidden')
    }
  }, [me, router.isReady, router.pathname])

  return null
}

function MyApp({ Component, pageProps }: AppProps) {
  usePagesViews()

  return (
    <>
      {/* @ts-ignore */}
      <Sentry.ErrorBoundary fallback={ErrorFallback}>
        <RecoilRoot>
          <Head>
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1.0"
            />
            <title>gigbase biz</title>
          </Head>
          <QueryClientProvider client={queryClient}>
            <ChakraProvider theme={theme}>
              <Component {...pageProps} />
              <BranchTermsModals />
              <AppInit />
              <GoogleAnalytics />
            </ChakraProvider>
          </QueryClientProvider>
        </RecoilRoot>
      </Sentry.ErrorBoundary>
    </>
  )
}

export default MyApp
